import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators, FormsModule } from "@angular/forms";
import { CommonSvgIconsComponent } from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import { NgClass, NgForOf } from "@angular/common";
import { TableService } from "../../../../core/services/table.service";
import { GeneralService } from "../../../../core/services/general.service";
import { VehicleService } from "../../../../core/services/vehicle.service";

@Component({
  selector: 'app-new-vehicle',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonSvgIconsComponent,
    NgClass,
    NgForOf
  ],
  templateUrl: './new-vehicle.component.html',
  styleUrl: './new-vehicle.component.scss'
})
export class NewVehicleComponent implements OnInit {
  @Input() sharedData: any;
  @Output() dataChanged = new EventEmitter<any>();

  public activeStep: number = 1;
  public validate: boolean = false;
  public searchNiv: string = '';
  public vehicleForm: FormGroup;
  @Output() activeSteps = new EventEmitter<number>();

  public vehicleBrandlist: any = [];
  public vehicleSubbrandist: any = [];
  public vehicleCategoryist: any = [];
  public vehicleVersionlist: any = [];
  public vehicleEquipmentList: any = [];
  public equipmentList: any[] = [];

  constructor(private fb: FormBuilder, private generalService: GeneralService, private tableService: TableService, private vehicleService: VehicleService) {
    this.vehicleForm = new FormGroup({
      id: new FormControl(0),
      plates: new FormControl("", Validators.required),
      niv: new FormControl(""),
      ns: new FormControl(""),
      brandId: new FormControl("", Validators.required),
      subBrandId: new FormControl("", Validators.required),
      categoryId: new FormControl(""),
      versionId: new FormControl(""),
      maintenanceKm: new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]+$") // Solo permite números
      ]),
      color: new FormControl("", Validators.required),
      interiorColor: new FormControl("", Validators.required),
      extintor: new FormControl("", Validators.required),
      gps: new FormControl("", Validators.required),
      year: new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]+$") // Solo permite números
      ]),
      fuelTag: new FormControl("", Validators.required),
      tollTag: new FormControl("", Validators.required),
      transmission: new FormControl(""),
      equipmentList: new FormGroup({}),
    });
  }


  ngOnInit(): void {
    this.vehicleForm.reset();
    this.loadList({
      "conditionColumn": "configurableListsField",
      "conditionValue": "vehicle equipamiento",
      "idColumn": "idconfigurableLists",
      "table": "confList",
      "valueColumn": "configurableListsCode"
    }, (value) => {
      this.equipmentList = value;

      this.addCheckboxes();
    });

    this.loadList({
      "conditionColumn": "configurableListsField",
      "conditionValue": "vehiculo marca",
      "idColumn": "idconfigurableLists",
      "table": "confList",
      "valueColumn": "configurableListsCode"
    }, (value) => { this.vehicleBrandlist = value; });

    this.loadList({
      "conditionColumn": "configurableListsField",
      "conditionValue": "Categoría de vehículos",
      "idColumn": "idconfigurableLists",
      "table": "listCategory",
      "valueColumn": "configurableListsCode"
    }, (value) => { this.vehicleCategoryist = value; });

    this.loadList({
      "conditionColumn": "configurableListsField",
      "conditionValue": "vehiculo version",
      "idColumn": "idconfigurableLists",
      "table": "confList",
      "valueColumn": "configurableListsCode"
    }, (value) => { this.vehicleVersionlist = value; });



  }
  addCheckboxes() {
    const equipmentGroup = this.vehicleForm.get('equipmentList') as FormGroup;
    this.equipmentList.forEach((eq: any) => {
      equipmentGroup.addControl(eq.id, new FormControl(false))
    });
  }

  next() {
    //const number = this.activeStep + 1;
    //this.activeSteps.emit(number);
    if (this.vehicleForm.invalid) {
      this.validate = true;
    } else {
      this.vehicleService.addVehicle(this.vehicleForm.value).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            this.dataChanged.emit(res.data);
            this.generalService.showMessage('success', res.message);

            const number = this.activeStep + 1;
            this.activeSteps.emit(number);
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
      );
    }
  }
  findVehicle() {
    if (!this.searchNiv) {
      this.generalService.showMessage('warn', 'Ingrese un término de búsqueda.');
      return;
    }
    this.vehicleService.findVehicle(this.searchNiv, 'add').subscribe(
      (res: any) => {
        if (res.error) {
          this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
        } else {
          if (res.data != 0) {
            this.loadSubBrandVehicle(res.data.vehicle.brandId);
            this.vehicleForm.patchValue(res.data.vehicle);
            const equipmentVehicle = res.data.equipment;
            if (equipmentVehicle.length > 0) {
              const equipmentGroup = this.vehicleForm.get('equipmentList') as FormGroup;
              equipmentVehicle.forEach((e: any) => {
                equipmentGroup.get(e.equipmentId.toString())?.setValue(true);
              });
            }
            this.dataChanged.emit(res.data.vehicle.id);
            this.generalService.showMessage('success', res.message);
          } else {
            this.generalService.showMessage('success', res.message);
          }
        }
      },
      (err) => {
        this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
      }
    )
  }

  loadList(config: any, setVariable: (value: any) => void): void {
    this.tableService.loadSelectOptions(config).subscribe(
      (res: any) => {
        if (res.error) {
          this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          setVariable([]);
        } else {
          setVariable(res['message']);
        }
      },
      (err) => {
        this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        setVariable([]);
      }
    );
  }

  loadSubBrandVehicle(idVehicleBrand: any) {
    this.loadList({
      "conditionColumn": "configurableListsDependence",
      "conditionValue": idVehicleBrand,
      "idColumn": "idconfigurableLists",
      "table": "confList",
      "valueColumn": "configurableListsCode"
    }, (value) => { this.vehicleSubbrandist = value; });
  }

  onSelectSubBrand(event: Event) {
    const idVehicleBrand = (event.target as HTMLSelectElement).value;
    this.loadSubBrandVehicle(idVehicleBrand);
  }

  get vehiclePlate() {
    return this.vehicleForm.get('plates');
  }
  get vehicleYear() {
    return this.vehicleForm.get('year');
  }
  get vehicleBrand() {
    return this.vehicleForm.get("brandId");
  }
  get vehicleSubbrand() {
    return this.vehicleForm.get("subBrandId");
  }
  get vehicleCategory() {
    return this.vehicleForm.get("categoryId");
  }
  get vehicleVersion() {
    return this.vehicleForm.get("versionId");
  }
  get vehicleKmMtto() {
    return this.vehicleForm.get("maintenanceKm");
  }
  get vehicleColor() {
    return this.vehicleForm.get("color");
  }
  get vehicleInteriorColor() {
    return this.vehicleForm.get("interiorColor");
  }
  get vehicleGps() {
    return this.vehicleForm.get("gps");
  }
  get vehicleFuel() {
    return this.vehicleForm.get("fuelTag");
  }
  get vehicleFoll() {
    return this.vehicleForm.get("tollTag");
  }
  get vehicleExtintor() {
    return this.vehicleForm.get("extintor");
  }



  /*ngOnDestroy(): void {
    this.editor.destroy();
  }*/
}
